import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import { isEmpty, isString } from 'lodash'

export const getUserLabel = (user) => {
  if (isString(user)) return user
  const { firstName, lastName, name, email } = user || {}

  const hasFirstNameAndLastName = !isEmpty(firstName) && !isEmpty(lastName)
  const hasName = !isEmpty(name)
  return hasFirstNameAndLastName ? `${firstName} ${lastName}` : hasName ? name : email
}

const UserCellRenderer = (props) => {
  const { value } = props
  const styles = useStyles()

  if (!Array.isArray(value) || value.length === 0) {
    return null
  }

  return (
    <div className={styles.container}>
      {value?.map((clerk) => {
        const label = getUserLabel(clerk)

        return (
          <div className={styles.pill} key={clerk.id}>{label}</div>
        )
      })}
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
  },
  pill: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.backgroundLight,
    borderRadius: 20,
    padding: '5px 8px 4px',
    fontSize: theme.fontSizes.smaller,
    lineHeight: '20px',
    margin: '5px 0',
    border: theme.border,
  },
}))

UserCellRenderer.propTypes = {
  value: PropTypes.object,
}

export default UserCellRenderer
